var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 33,
    viewBox: "0 0 45 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 7C0.5 3.41015 3.41015 0.5 7 0.5H38C41.5899 0.5 44.5 3.41015 44.5 7V26C44.5 29.5899 41.5899 32.5 38 32.5H7C3.41015 32.5 0.5 29.5899 0.5 26V7ZM7 3.5C5.067 3.5 3.5 5.067 3.5 7V26C3.5 27.933 5.067 29.5 7 29.5H38C39.933 29.5 41.5 27.933 41.5 26V7C41.5 5.067 39.933 3.5 38 3.5H7Z",
    fill: "#14142B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43 14.1836H2V11.1836H43V14.1836Z",
    fill: "#14142B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.57422 24.625C6.57422 23.7966 7.24579 23.125 8.07422 23.125H14.1483C14.9767 23.125 15.6483 23.7966 15.6483 24.625C15.6483 25.4534 14.9767 26.125 14.1483 26.125H8.07422C7.24579 26.125 6.57422 25.4534 6.57422 24.625Z",
    fill: "#14142B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentIcon);
export default __webpack_public_path__ + "static/media/paymentIcon.e1db6d9ce230e7d3c3db9517fbf95310.svg";
export { ForwardRef as ReactComponent };